import { Build } from '@stencil/core';

const cache: Map<string, any> = new Map();

if (Build.isBrowser) {
  (TYPO3.xhrCache || []).forEach(entry => addToCache(entry.url, entry.data));
} else if (Build.isServer) {
  const settings = JSON.parse(document.querySelector('body').getAttribute('data-nlx-ssr-settings')) || {};
  (settings.xhrCache || []).forEach(entry => addToCache(entry.url, entry.data));
}

export function normalizeUrl(url: string): string {
  const urlObject = document.createElement('a');
  urlObject.href = url.replace('%20', '+');
  return urlObject.href;
}

function addToCache(url: string, response: any) {
  const normalizedUrl = normalizeUrl(url);
  cache.set(normalizedUrl, JSON.stringify(response));
  return response;
}

function readFromCache(url: string): any {
  const normalizedUrl = normalizeUrl(url);
  return JSON.parse(cache.get(normalizedUrl));
}

async function loadFromUrl(url: string, useCache = true): Promise<any> {
  const normalizedUrl = normalizeUrl(url);
  if (useCache && cache.has(normalizedUrl)) {
    return readFromCache(normalizedUrl);
  } else {
    return await fetch(normalizedUrl, {
      headers: {
        accept: 'application/json',
      },
    })
      .then(response => response.json())
      .then(response => addToCache(normalizedUrl, response));
  }
}

export function get(url: string, useCache = true): Promise<any> {
  return loadFromUrl(url, useCache);
}
